/**
 * Demo Project 2: "Stickman vs. neviditelna kamera"
 * 60 seconds @ 24fps = 1440 frames
 *
 * Scene 1 (0-12s, f0-288):    Stickman vchazi, uvidi kameru, HNED reaguje - poskoky, ukazovani
 * Scene 2 (12-28s, f288-672):  Show pro kameru - tanec, grimasy, akrobacie, palce nahoru
 * Scene 3 (28-40s, f672-960):  Zjisti ze kamera je jeho ruka - sok, zkoumani, panika
 * Scene 4 (40-52s, f960-1248): Boj s kamerou - pesti, kopy, nabeh
 * Scene 5 (52-60s, f1248-1440): Bouchne do kamery → obraz prasknue a rozbije se
 */

const W = 800, H = 600, CX = 400, CY = 330;

function kf(frame, props) {
  return { frame, rotation: 0, scaleX: 1, scaleY: 1, opacity: 1, ...props };
}

// Default limb state
const D = {
  x: CX, y: CY, rotation: 0, scaleX: 1, scaleY: 1, opacity: 1,
  headAngle: 0, leftArmAngle: 0, rightArmAngle: 0,
  leftForearmAngle: 0, rightForearmAngle: 0,
  leftLegAngle: 0, rightLegAngle: 0,
  leftShinAngle: 0, rightShinAngle: 0,
  mouthWidth: 3, eyebrowAngle: 0,
};

function stickmanKeyframes() {
  const k = [];

  // === SCENE 1: Vchazi, uvidi kameru (0-288) - DYNAMICKY od zacatku ===

  // Enter from left, walking
  k.push(kf(0,   { ...D, x: 50, y: CY, opacity: 0 }));
  k.push(kf(12,  { ...D, x: 80,  opacity: 1, leftLegAngle: -20, rightLegAngle: 20, leftArmAngle: 15, rightArmAngle: -15 }));
  k.push(kf(24,  { ...D, x: 130, leftLegAngle: 20, rightLegAngle: -20, leftArmAngle: -15, rightArmAngle: 15 }));
  k.push(kf(36,  { ...D, x: 180, leftLegAngle: -20, rightLegAngle: 20, leftArmAngle: 15, rightArmAngle: -15 }));
  k.push(kf(48,  { ...D, x: 230, leftLegAngle: 20, rightLegAngle: -20, leftArmAngle: -15, rightArmAngle: 15 }));
  k.push(kf(60,  { ...D, x: 280, leftLegAngle: -15, rightLegAngle: 15, leftArmAngle: 10, rightArmAngle: -10 }));
  // Stop, notice camera - FREEZE
  k.push(kf(72,  { ...D, x: 320, headAngle: 0, mouthWidth: 2, eyebrowAngle: -2 }));
  // Double take! - quick head snap
  k.push(kf(84,  { ...D, x: 320, headAngle: -25, mouthWidth: 1, eyebrowAngle: -5 }));
  k.push(kf(90,  { ...D, x: 320, headAngle: 15, mouthWidth: 6, eyebrowAngle: -8 }));
  // Jump back scared!
  k.push(kf(102, { ...D, x: 380, y: CY - 30, headAngle: 0, mouthWidth: 9, eyebrowAngle: -10, leftArmAngle: -50, rightArmAngle: 50, leftForearmAngle: 30, rightForearmAngle: -30, leftLegAngle: -25, rightLegAngle: 25 }));
  // Land, crouch
  k.push(kf(114, { ...D, x: 380, y: CY + 10, mouthWidth: 5, eyebrowAngle: -6, leftArmAngle: 30, rightArmAngle: -30, leftLegAngle: -20, rightLegAngle: 20, leftShinAngle: 10, rightShinAngle: -10 }));
  // Point at camera!
  k.push(kf(132, { ...D, x: 370, headAngle: -5, mouthWidth: 7, eyebrowAngle: -5, rightArmAngle: -100, rightForearmAngle: -20, leftArmAngle: 20 }));
  // Look around nervously - quick!
  k.push(kf(150, { ...D, x: 370, headAngle: -30, mouthWidth: 4, eyebrowAngle: -4, rightArmAngle: -80, rightForearmAngle: -30, leftArmAngle: 25 }));
  k.push(kf(162, { ...D, x: 370, headAngle: 30, mouthWidth: 4, eyebrowAngle: -4 }));
  k.push(kf(174, { ...D, x: 370, headAngle: -15, mouthWidth: 3 }));
  // Sneak closer to camera
  k.push(kf(200, { ...D, x: 350, headAngle: 5, mouthWidth: 2, eyebrowAngle: -3, leftLegAngle: -15, rightLegAngle: 15, leftArmAngle: 20, rightArmAngle: -20 }));
  k.push(kf(220, { ...D, x: 380, headAngle: -5, leftLegAngle: 15, rightLegAngle: -15, leftArmAngle: -20, rightArmAngle: 20 }));
  // Peek at camera - lean forward
  k.push(kf(250, { ...D, x: CX, y: CY - 5, headAngle: -8, mouthWidth: 4, eyebrowAngle: -6, leftArmAngle: 25, rightArmAngle: -25, rotation: -5 }));
  // Straighten up - OK, it's a camera!
  k.push(kf(276, { ...D, x: CX, headAngle: 0, mouthWidth: 6, eyebrowAngle: -3 }));

  // === SCENE 2: Show pro kameru (288-672) - HODNE akce ===

  // Thumbs up + big grin
  k.push(kf(300, { ...D, x: CX, mouthWidth: 8, eyebrowAngle: -2, rightArmAngle: -90, rightForearmAngle: -50 }));
  // Wave madly
  k.push(kf(324, { ...D, x: CX, mouthWidth: 7, leftArmAngle: -100, leftForearmAngle: -40, rightArmAngle: -90, rightForearmAngle: -50 }));
  k.push(kf(340, { ...D, x: CX, mouthWidth: 7, leftArmAngle: -70, leftForearmAngle: -60, rightArmAngle: -110, rightForearmAngle: -30 }));
  k.push(kf(356, { ...D, x: CX, mouthWidth: 7, leftArmAngle: -100, leftForearmAngle: -40, rightArmAngle: -70, rightForearmAngle: -60 }));
  // Grimace 1 - stretch face wide
  k.push(kf(380, { ...D, x: CX, headAngle: -10, mouthWidth: 12, eyebrowAngle: -10, leftArmAngle: -40, rightArmAngle: 40, leftForearmAngle: 30, rightForearmAngle: -30 }));
  // Grimace 2 - sad clown
  k.push(kf(404, { ...D, x: CX, headAngle: 10, mouthWidth: -7, eyebrowAngle: 6, leftArmAngle: 15, rightArmAngle: -15 }));
  // Grimace 3 - tongue out (big open mouth)
  k.push(kf(420, { ...D, x: CX, headAngle: 0, mouthWidth: 14, eyebrowAngle: -4, leftArmAngle: -30, rightArmAngle: 30, leftForearmAngle: -20, rightForearmAngle: 20 }));
  // DANCE! - Disco move 1
  k.push(kf(444, { ...D, x: CX - 40, y: CY - 15, headAngle: 15, mouthWidth: 6, leftArmAngle: -110, rightArmAngle: 30, leftForearmAngle: -30, leftLegAngle: -30, rightLegAngle: 15, leftShinAngle: 15 }));
  // Disco move 2
  k.push(kf(468, { ...D, x: CX + 40, y: CY - 15, headAngle: -15, mouthWidth: 6, rightArmAngle: -110, leftArmAngle: 30, rightForearmAngle: -30, rightLegAngle: -30, leftLegAngle: 15, rightShinAngle: 15 }));
  // Disco move 3 - spin
  k.push(kf(492, { ...D, x: CX, y: CY - 10, rotation: 180, mouthWidth: 8, leftArmAngle: -60, rightArmAngle: 60 }));
  k.push(kf(510, { ...D, x: CX, y: CY - 10, rotation: 360, mouthWidth: 8 }));
  // Moonwalk left
  k.push(kf(528, { ...D, x: CX - 30, headAngle: 10, mouthWidth: 5, leftLegAngle: 25, rightLegAngle: -10, leftShinAngle: -15, leftArmAngle: -20, rightArmAngle: 20 }));
  k.push(kf(546, { ...D, x: CX - 60, headAngle: 10, mouthWidth: 5, rightLegAngle: 25, leftLegAngle: -10, rightShinAngle: -15, leftArmAngle: 20, rightArmAngle: -20 }));
  k.push(kf(564, { ...D, x: CX - 90, headAngle: 10, mouthWidth: 5, leftLegAngle: 25, rightLegAngle: -10, leftShinAngle: -15 }));
  // JUMP! - high jump
  k.push(kf(588, { ...D, x: CX, y: CY - 80, mouthWidth: 10, eyebrowAngle: -6, leftArmAngle: -120, rightArmAngle: -120, leftForearmAngle: -20, rightForearmAngle: 20, leftLegAngle: -40, rightLegAngle: 40, leftShinAngle: 30, rightShinAngle: -30 }));
  // Land with flair
  k.push(kf(612, { ...D, x: CX, y: CY + 10, mouthWidth: 7, leftArmAngle: -60, rightArmAngle: 60, leftLegAngle: -15, rightLegAngle: 15, leftShinAngle: 8, rightShinAngle: -8, scaleX: 1.1, scaleY: 0.9 }));
  // Ta-da pose!
  k.push(kf(636, { ...D, x: CX, mouthWidth: 9, eyebrowAngle: -3, leftArmAngle: -120, rightArmAngle: -120, leftForearmAngle: -30, rightForearmAngle: 30 }));
  // Bow
  k.push(kf(660, { ...D, x: CX, rotation: 15, mouthWidth: 5, headAngle: 20, leftArmAngle: 30, rightArmAngle: -30 }));

  // === SCENE 3: Zjisti ze kamera = jeho ruka (672-960) ===

  // Stand up, something's wrong...
  k.push(kf(690, { ...D, x: CX, headAngle: 10, mouthWidth: 3, eyebrowAngle: -3, rightArmAngle: -60, rightForearmAngle: -40 }));
  // Look at right hand suspiciously
  k.push(kf(720, { ...D, x: CX, headAngle: 25, mouthWidth: 1, eyebrowAngle: -5, rightArmAngle: -80, rightForearmAngle: -70 }));
  // Hand up to face - examine closely
  k.push(kf(756, { ...D, x: CX, headAngle: 20, mouthWidth: 0, eyebrowAngle: -7, rightArmAngle: -110, rightForearmAngle: -80 }));
  // WAIT... Move hand, camera moves?
  k.push(kf(780, { ...D, x: CX - 20, headAngle: 15, mouthWidth: 2, rightArmAngle: -90, rightForearmAngle: -60, leftArmAngle: 10 }));
  k.push(kf(804, { ...D, x: CX + 20, headAngle: -15, mouthWidth: 2, rightArmAngle: -70, rightForearmAngle: -80 }));
  // SHOCK!!!! - eyes wide, jump
  k.push(kf(828, { ...D, x: CX + 50, y: CY - 30, headAngle: 0, mouthWidth: 14, eyebrowAngle: -12, leftArmAngle: -70, rightArmAngle: 70, leftForearmAngle: 30, rightForearmAngle: -30, leftLegAngle: -20, rightLegAngle: 20 }));
  // Look at left hand too
  k.push(kf(864, { ...D, x: CX + 30, headAngle: -30, mouthWidth: 10, eyebrowAngle: -10, leftArmAngle: -90, leftForearmAngle: -70, rightArmAngle: 30 }));
  // Look at right hand
  k.push(kf(888, { ...D, x: CX + 30, headAngle: 30, mouthWidth: 10, eyebrowAngle: -10, rightArmAngle: -90, rightForearmAngle: -70, leftArmAngle: 30, leftForearmAngle: 0 }));
  // PANIC - run in circle
  k.push(kf(912, { ...D, x: CX - 60, y: CY - 10, headAngle: -20, mouthWidth: 8, eyebrowAngle: -8, leftLegAngle: -30, rightLegAngle: 30, leftArmAngle: -40, rightArmAngle: 40 }));
  k.push(kf(936, { ...D, x: CX + 60, y: CY - 10, headAngle: 20, mouthWidth: 8, eyebrowAngle: -8, leftLegAngle: 30, rightLegAngle: -30, leftArmAngle: 40, rightArmAngle: -40 }));
  // Angry face - enough!
  k.push(kf(952, { ...D, x: CX, headAngle: 0, mouthWidth: -6, eyebrowAngle: 8, leftArmAngle: 20, rightArmAngle: -20 }));

  // === SCENE 4: Boj s kamerou (960-1248) - INTENZIVNI ===

  // Wind up RIGHT punch
  k.push(kf(976, { ...D, x: CX + 30, headAngle: -8, mouthWidth: -5, eyebrowAngle: 8, rightArmAngle: 70, rightForearmAngle: 60, leftArmAngle: -30, leftLegAngle: -10, rightLegAngle: 10 }));
  // PUNCH RIGHT!
  k.push(kf(990, { ...D, x: CX - 10, headAngle: 5, mouthWidth: 10, eyebrowAngle: 7, rightArmAngle: -110, rightForearmAngle: -15, leftArmAngle: 30, leftLegAngle: 15, rightLegAngle: -5 }));
  // Wind up LEFT punch
  k.push(kf(1010, { ...D, x: CX - 20, headAngle: 8, mouthWidth: -5, eyebrowAngle: 8, leftArmAngle: 70, leftForearmAngle: 60, rightArmAngle: -20, rightForearmAngle: 0 }));
  // PUNCH LEFT!
  k.push(kf(1024, { ...D, x: CX + 20, headAngle: -5, mouthWidth: 10, eyebrowAngle: 7, leftArmAngle: -110, leftForearmAngle: -15, rightArmAngle: 30, rightForearmAngle: 0 }));
  // Rapid combo!
  k.push(kf(1044, { ...D, x: CX, mouthWidth: 9, eyebrowAngle: 8, rightArmAngle: -100, rightForearmAngle: -10, leftArmAngle: 30 }));
  k.push(kf(1060, { ...D, x: CX, mouthWidth: 9, eyebrowAngle: 8, leftArmAngle: -100, leftForearmAngle: -10, rightArmAngle: 30, rightForearmAngle: 0 }));
  k.push(kf(1076, { ...D, x: CX, mouthWidth: 9, rightArmAngle: -100, rightForearmAngle: -10, leftArmAngle: 30, leftForearmAngle: 0 }));
  // HIGH KICK!
  k.push(kf(1100, { ...D, x: CX, y: CY - 10, mouthWidth: 12, eyebrowAngle: 9, rightLegAngle: -70, rightShinAngle: -40, leftLegAngle: 10, leftArmAngle: 40, rightArmAngle: -40, rightForearmAngle: 0, leftForearmAngle: 0 }));
  // Recover
  k.push(kf(1120, { ...D, x: CX, mouthWidth: 7, eyebrowAngle: 6 }));
  // Running start - back up
  k.push(kf(1150, { ...D, x: CX + 100, mouthWidth: -6, eyebrowAngle: 9, leftLegAngle: 15, rightLegAngle: -15, leftArmAngle: -15, rightArmAngle: 15 }));
  k.push(kf(1170, { ...D, x: CX + 80, leftLegAngle: -20, rightLegAngle: 20, leftArmAngle: 20, rightArmAngle: -20, mouthWidth: -5, eyebrowAngle: 9 }));
  // CHARGE!!!! - running toward camera
  k.push(kf(1190, { ...D, x: CX + 40, leftLegAngle: 25, rightLegAngle: -25, leftArmAngle: -25, rightArmAngle: 25, mouthWidth: 10, eyebrowAngle: 10 }));
  k.push(kf(1210, { ...D, x: CX - 10, leftLegAngle: -25, rightLegAngle: 25, leftArmAngle: 25, rightArmAngle: -25, mouthWidth: 12, eyebrowAngle: 10 }));
  // FINAL WIND UP - both fists back
  k.push(kf(1230, { ...D, x: CX - 40, y: CY + 5, mouthWidth: -8, eyebrowAngle: 10, leftArmAngle: 60, rightArmAngle: -60, leftForearmAngle: 50, rightForearmAngle: -50, leftLegAngle: -20, rightLegAngle: 20 }));

  // === SCENE 5: BOUCHNE DO KAMERY (1248-1440) ===

  // MEGA PUNCH - both fists FORWARD into camera!
  k.push(kf(1260, { ...D, x: CX - 80, y: CY - 20, mouthWidth: 14, eyebrowAngle: 10, leftArmAngle: -110, rightArmAngle: 110, leftForearmAngle: -10, rightForearmAngle: 10, leftLegAngle: 20, rightLegAngle: -10, scaleX: 1.4, scaleY: 1.4 }));
  // Impact! - shake
  k.push(kf(1272, { ...D, x: CX - 70, y: CY - 15, mouthWidth: 14, eyebrowAngle: 8, leftArmAngle: -100, rightArmAngle: 100, scaleX: 1.3, scaleY: 1.3, rotation: -3 }));
  k.push(kf(1284, { ...D, x: CX - 75, y: CY - 18, rotation: 3, scaleX: 1.3, scaleY: 1.3, mouthWidth: 12, leftArmAngle: -95, rightArmAngle: 95 }));
  // Step back, victorious pose
  k.push(kf(1320, { ...D, x: CX, y: CY - 10, mouthWidth: 10, eyebrowAngle: -5, leftArmAngle: -120, rightArmAngle: -120, leftForearmAngle: -30, rightForearmAngle: 30, scaleX: 1.1, scaleY: 1.1 }));
  // Fall through broken screen
  k.push(kf(1380, { ...D, x: CX, y: CY + 60, mouthWidth: 8, eyebrowAngle: -8, leftArmAngle: -50, rightArmAngle: 50, leftLegAngle: -20, rightLegAngle: 20, scaleX: 0.6, scaleY: 0.6, opacity: 0.7 }));
  // Gone
  k.push(kf(1420, { ...D, x: CX, y: CY + 120, opacity: 0, scaleX: 0.2, scaleY: 0.2 }));
  k.push(kf(1440, { ...D, x: CX, y: CY + 120, opacity: 0, scaleX: 0.1, scaleY: 0.1 }));

  return k;
}

function titleObj(id, text, fill, startFrame, endFrame, fontSize) {
  return {
    id, type: "text", name: text, x: CX, y: 35, width: 600, height: 60,
    rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
    fill, text, fontSize: fontSize || 26, stroke: "", strokeWidth: 0, easing: "easeInOut",
    keyframes: [
      kf(startFrame, { x: CX, y: 35, opacity: 0, scaleX: 0.8, scaleY: 0.8 }),
      kf(startFrame + 12, { x: CX, y: 35, opacity: 1, scaleX: 1, scaleY: 1 }),
      kf(endFrame - 12, { x: CX, y: 35, opacity: 1 }),
      kf(endFrame, { x: CX, y: 35, opacity: 0 }),
    ],
  };
}

// Camera icon made of rects (body + lens + red light)
function cameraObjects() {
  const objs = [];
  // Camera body - dark rect
  objs.push({
    id: "obj-cam-body", type: "rect", name: "Kamera telo",
    x: CX, y: 80, width: 70, height: 45,
    rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
    fill: "#2d2d2d", stroke: "#555", strokeWidth: 2,
    keyframes: [
      kf(0, { x: CX, y: 80, opacity: 0 }),
      kf(48, { x: CX, y: 80, opacity: 0 }),
      kf(72, { x: CX, y: 80, opacity: 0.9 }),
      kf(1248, { x: CX, y: 80, opacity: 0.9 }),
      // Impact shake
      kf(1260, { x: CX + 8, y: 75, opacity: 1, rotation: -5 }),
      kf(1272, { x: CX - 10, y: 82, opacity: 1, rotation: 8 }),
      kf(1284, { x: CX + 5, y: 78, opacity: 1, rotation: -3 }),
      kf(1296, { x: CX, y: 80, opacity: 0.6, rotation: 15 }),
      kf(1320, { x: CX + 30, y: 140, opacity: 0, rotation: 45, scaleX: 0.5, scaleY: 0.5 }),
      kf(1440, { x: CX + 30, y: 200, opacity: 0 }),
    ],
  });
  // Camera lens - circle
  objs.push({
    id: "obj-cam-lens", type: "ellipse", name: "Objektiv",
    x: CX - 5, y: 80, width: 28, height: 28,
    rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
    fill: "#1a1a2e", stroke: "#888", strokeWidth: 2,
    keyframes: [
      kf(0, { x: CX - 5, y: 80, opacity: 0 }),
      kf(48, { x: CX - 5, y: 80, opacity: 0 }),
      kf(72, { x: CX - 5, y: 80, opacity: 0.9 }),
      kf(1248, { x: CX - 5, y: 80, opacity: 0.9 }),
      kf(1260, { x: CX + 3, y: 75, opacity: 1, rotation: -5 }),
      kf(1272, { x: CX - 15, y: 82, opacity: 1, rotation: 8 }),
      kf(1296, { x: CX - 5, y: 80, opacity: 0.5, rotation: 15 }),
      kf(1320, { x: CX + 25, y: 140, opacity: 0, rotation: 45 }),
      kf(1440, { x: CX + 25, y: 200, opacity: 0 }),
    ],
  });
  // Lens inner - bright glass
  objs.push({
    id: "obj-cam-glass", type: "ellipse", name: "Sklo",
    x: CX - 5, y: 80, width: 16, height: 16,
    rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
    fill: "#4a90d9", stroke: "", strokeWidth: 0,
    keyframes: [
      kf(0, { x: CX - 5, y: 80, opacity: 0 }),
      kf(72, { x: CX - 5, y: 80, opacity: 0.7 }),
      kf(1248, { x: CX - 5, y: 80, opacity: 0.7 }),
      kf(1260, { x: CX + 3, y: 75, opacity: 0.9 }),
      kf(1296, { x: CX - 5, y: 80, opacity: 0.3 }),
      kf(1320, { x: CX + 25, y: 140, opacity: 0 }),
      kf(1440, { x: CX + 25, y: 200, opacity: 0 }),
    ],
  });
  // REC light - small red dot
  const recKfs = [];
  for (let f = 72; f <= 1248; f += 36) {
    recKfs.push(kf(f, { x: CX + 28, y: 64, opacity: (f / 36) % 2 === 0 ? 0.9 : 0.2 }));
  }
  recKfs.unshift(kf(0, { x: CX + 28, y: 64, opacity: 0 }));
  recKfs.push(kf(1260, { x: CX + 36, y: 59, opacity: 1 }));
  recKfs.push(kf(1296, { x: CX + 28, y: 64, opacity: 0 }));
  recKfs.push(kf(1440, { x: CX + 28, y: 64, opacity: 0 }));

  objs.push({
    id: "obj-cam-rec", type: "ellipse", name: "REC svetlo",
    x: CX + 28, y: 64, width: 8, height: 8,
    rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
    fill: "#ef4444", stroke: "", strokeWidth: 0,
    keyframes: recKfs,
  });

  // REC text
  const recTxtKfs = [];
  for (let f = 72; f <= 1248; f += 36) {
    recTxtKfs.push(kf(f, { x: 60, y: 25, opacity: (f / 36) % 2 === 0 ? 0.8 : 0.15 }));
  }
  recTxtKfs.unshift(kf(0, { x: 60, y: 25, opacity: 0 }));
  recTxtKfs.push(kf(1260, { x: 60, y: 25, opacity: 1 }));
  recTxtKfs.push(kf(1296, { x: 60, y: 25, opacity: 0 }));
  recTxtKfs.push(kf(1440, { x: 60, y: 25, opacity: 0 }));

  objs.push({
    id: "obj-rec-text", type: "text", name: "REC",
    x: 60, y: 25, width: 40, height: 20,
    rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
    fill: "#ef4444", text: "REC", fontSize: 14, stroke: "", strokeWidth: 0,
    keyframes: recTxtKfs,
  });

  return objs;
}

// Screen crack effects - appear when stickman hits camera
function generateCracks() {
  const cracks = [];
  const crackDefs = [
    { points: [400, 80, 390, 150, 370, 250, 340, 350, 300, 450, 260, 550, 230, 600], delay: 0 },
    { points: [400, 80, 410, 160, 440, 270, 480, 380, 510, 490, 540, 580, 570, 600], delay: 2 },
    { points: [400, 80, 350, 130, 280, 180, 200, 230, 120, 260, 40, 290, 0, 310], delay: 3 },
    { points: [400, 80, 450, 120, 520, 170, 600, 200, 700, 240, 800, 270], delay: 4 },
    { points: [400, 80, 380, 120, 340, 90, 300, 50, 260, 20, 220, 0], delay: 5 },
    { points: [400, 80, 420, 110, 460, 60, 500, 30, 550, 0], delay: 6 },
    { points: [0, 350, 120, 340, 250, 360, 400, 350, 550, 340, 700, 360, 800, 350], delay: 8 },
    { points: [400, 80, 360, 160, 300, 280, 240, 400, 180, 500, 120, 600], delay: 1 },
    { points: [400, 80, 440, 170, 500, 300, 560, 430, 620, 550, 680, 600], delay: 2 },
  ];

  crackDefs.forEach((cd, i) => {
    const startF = 1260 + cd.delay;
    cracks.push({
      id: `obj-crack-${i}`, type: "path", name: `Prasklina ${i + 1}`,
      x: 0, y: 0, width: 800, height: 600,
      rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
      fill: "", stroke: "#ffffff", strokeWidth: 2 + (i < 2 ? 2 : 0),
      points: cd.points,
      keyframes: [
        kf(startF, { x: 0, y: 0, opacity: 0 }),
        kf(startF + 3, { x: 0, y: 0, opacity: 0.9 }),
        kf(1440, { x: 0, y: 0, opacity: 1 }),
      ],
    });
  });

  // Glass shards falling
  const shards = [
    { x: 200, y: 150, w: 100, h: 80, rot: -15, dx: -40, dy: 200 },
    { x: 600, y: 120, w: 90, h: 100, rot: 20, dx: 50, dy: 220 },
    { x: 150, y: 400, w: 120, h: 90, rot: 12, dx: -60, dy: 150 },
    { x: 650, y: 380, w: 110, h: 80, rot: -18, dx: 40, dy: 160 },
    { x: 350, y: 200, w: 80, h: 120, rot: 8, dx: -20, dy: 180 },
    { x: 500, y: 250, w: 90, h: 70, rot: -10, dx: 30, dy: 170 },
  ];

  shards.forEach((s, i) => {
    cracks.push({
      id: `obj-shard-${i}`, type: "rect", name: `Strepina ${i + 1}`,
      x: s.x, y: s.y, width: s.w, height: s.h,
      rotation: 0, scaleX: 1, scaleY: 1, opacity: 0,
      fill: "rgba(10,10,30,0.7)", stroke: "#ffffff", strokeWidth: 1,
      keyframes: [
        kf(1280, { x: s.x, y: s.y, rotation: 0, opacity: 0 }),
        kf(1296, { x: s.x, y: s.y, rotation: 0, opacity: 0.8 }),
        kf(1440, { x: s.x + s.dx, y: s.y + s.dy, rotation: s.rot, opacity: 0.9 }),
      ],
    });
  });

  return cracks;
}

// Simple background
function bgObjects() {
  return [
    {
      id: "obj-wall", type: "rect", name: "Stena",
      x: 400, y: 215, width: 800, height: 430,
      rotation: 0, scaleX: 1, scaleY: 1, opacity: 1,
      fill: "#f5f0eb", stroke: "", strokeWidth: 0,
      keyframes: [
        kf(0, { x: 400, y: 215, opacity: 1 }),
        kf(1248, { x: 400, y: 215, opacity: 1 }),
        kf(1320, { x: 400, y: 215, opacity: 0.4 }),
        kf(1440, { x: 400, y: 215, opacity: 0 }),
      ],
    },
    {
      id: "obj-floor", type: "rect", name: "Podlaha",
      x: 400, y: 520, width: 800, height: 180,
      rotation: 0, scaleX: 1, scaleY: 1, opacity: 1,
      fill: "#ddd5c8", stroke: "", strokeWidth: 0,
      keyframes: [
        kf(0, { x: 400, y: 520, opacity: 1 }),
        kf(1248, { x: 400, y: 520, opacity: 1 }),
        kf(1320, { x: 400, y: 520, opacity: 0.3 }),
        kf(1440, { x: 400, y: 620, opacity: 0 }),
      ],
    },
  ];
}

export function createStickmanDemo() {
  return {
    name: "Stickman vs. Kamera",
    width: W,
    height: H,
    fps: 24,
    totalFrames: 1440,
    layers: [
      { id: "layer-bg", name: "Pozadi", visible: true, locked: true, objects: bgObjects() },
      { id: "layer-camera", name: "Kamera", visible: true, locked: false, objects: cameraObjects() },
      {
        id: "layer-stickman", name: "Stickman", visible: true, locked: false,
        objects: [{
          id: "obj-stickman", type: "stickman", name: "Stickman",
          x: CX, y: CY, width: 80, height: 160,
          rotation: 0, scaleX: 1.8, scaleY: 1.8, opacity: 0,
          fill: "#222222", stroke: "", strokeWidth: 0,
          keyframes: stickmanKeyframes(),
        }],
      },
      {
        id: "layer-titles", name: "Titulky", visible: true, locked: false,
        objects: [
          titleObj("obj-t1", "Hm? Co je to?", "#666", 72, 200, 22),
          titleObj("obj-t2", "Hele, kamera!", "#444", 260, 310, 24),
          titleObj("obj-t3", "Ahoj vsichni!", "#333", 310, 420, 28),
          titleObj("obj-t4", "Sledujte tohle!", "#222", 430, 570, 26),
          titleObj("obj-t5", "Ta-daa!", "#d946ef", 624, 672, 30),
          titleObj("obj-t6", "Moment... to je...", "#666", 690, 810, 22),
          titleObj("obj-t7", "MOJE RUKA?!", "#dc2626", 828, 952, 34),
          titleObj("obj-t8", "ROZBIT!!!", "#ef4444", 960, 1200, 38),
          titleObj("obj-t9", "*PRASK!*", "#ffffff", 1260, 1440, 52),
        ],
      },
      { id: "layer-cracks", name: "Efekty", visible: true, locked: false, objects: generateCracks() },
    ],
  };
}
